<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import PagesList from "../../../components/albums/pages-list";
import PagesGrid from "../../../components/albums/pages-grid";
import api from "../../../services/api";
import Multiselect from "vue-multiselect";

export default {
  name: 'PageList',
  page: {
    title: "Albums",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PagesGrid,
    PagesList,
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    const canEdit = !!JSON.parse(localStorage.getItem('user')).roles.find((v) => v.name === 'admin');

    return {
      title: "Albums",
      items: [
        {
          text: "Albums",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      canEdit,
      displayMode: 'list',
      listAlbums: [],
      listVolumes: null,
      selectedAlbum: {id: "all", titre: "Tous"},
      selectedVolume: null,
      pages: [],
      filter: null,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      autoUpdateTotalRows: true,
      totalRows: 0,
      currentPage: 1,
      loading: false
    };
  },
  mounted() {
    this.getAlbums();
    this.updateListPages();
  },
  methods: {
    updateListPages(displayMode = 'list') {
      const objectAwaiting = displayMode === "grid";

      if (this.selectedAlbum.id === "all") {
        this.loading = true;
        this.autoUpdateTotalRows = false;

        this.getPagesForVolume().then((response) => {
          this.pages = this.pages.concat(response.data.data);
          this.totalRows = response.data.total;
          this.loading = false;
        });

        return;
      }

      this.autoUpdateTotalRows = true;
      this.currentPage = 1;

      if (this.selectedVolume === null || this.selectedVolume.id === "all") {
        let listPagesTemp = this.selectedAlbum.pages;

        if (objectAwaiting) {
          for (const volume of this.selectedAlbum.volumes) {
            for (const i in volume.pages) {
              listPagesTemp.push(volume.pages[i]);
            }
          }

          for (const i in this.selectedAlbum.pages_exclues) {
            listPagesTemp.push(this.selectedAlbum.pages_exclues[i]);
          }
        } else {
          for (const volume of this.selectedAlbum.volumes) {
            listPagesTemp = listPagesTemp.concat(volume.pages);
          }

          listPagesTemp = listPagesTemp.concat(this.selectedAlbum.pages_exclues);
        }

        /*listPagesTemp.sort((a, b) => this.albumSortKey(a.NumPageAlbum)
            .localeCompare(this.albumSortKey(b.NumPageAlbum)));*/

        this.pages = listPagesTemp;
      } else if (this.selectedVolume.id === "pages_supp") {
        this.pages = this.selectedAlbum.pages_exclues;
      } else {
        this.pages = this.selectedVolume.pages;
      }
    },
    albumSortKey(NumPageAlbum) {
      if (NumPageAlbum.length === 7) {
        return (
            NumPageAlbum.slice(-2) +
            NumPageAlbum.slice(0, 4) +
            NumPageAlbum.slice(3, 8)
        );
      } else {
        return (
            NumPageAlbum.slice(-2) +
            NumPageAlbum.slice(3, 7) +
            NumPageAlbum.slice(7, 8) +
            NumPageAlbum.slice(0, 3)
        );
      }
    },
    async getPagesForVolume(volume) {
      return api.get('pages', {
        albums: volume && volume.id && volume.id !== "all" ? volume.id : null,
        with: 'persons,inventories',
        page: this.currentPage,
        length: this.perPage,
        filter: this.filter,
      }, null, {}, 'getPagesForVolume');
    },
    getAlbums() {
      api.get('albums', {}).then((response) => {
        this.listAlbums = response.data.data;
        this.listVolumes = response.data.data.volumes && response.data.data.volumes.length > 0 ? response.data.data.volumes : null;

        this.listAlbums.unshift({titre: "Tous", id: "all", code: "all"});
      });
    },
    async changeSelectedAlbum(selectedOption) {
      const newIndexSelectedAlbum = selectedOption.id;
      this.selectedVolume = {id: "all", nom_volume: "Tous"};

      for (const index in this.listAlbums) {
        if (this.listAlbums[index].id === newIndexSelectedAlbum) {
          this.selectedAlbum = this.listAlbums[index];
          break;
        }
      }

      if (this.selectedAlbum.id !== "all") {
        const detailsSelectedAlbum = await this.getVolumesWithPages(this.displayMode === 'grid');
        Object.assign(this.selectedAlbum, detailsSelectedAlbum.data.data);

        this.updateListVolumes(this.displayMode);
      } else {
        this.displayMode = 'list';
        this.listVolumes = null;
      }

      this.pages = [];
      this.currentPage = 1;
      this.updateListPages(this.displayMode);
    },
    async changeSelectedVolume(event) {
      this.selectedVolume = this.listVolumes[event.target.value];
      this.pages = [];
      this.currentPage = 1;
      this.updateListPages();
    },
    getVolumesWithPages(groupedPages = false) {
      return api.get('albums', {
        id: this.selectedAlbum.id,
        with: "pages,volumes,pages.inventories,pages.persons",
        grouped: groupedPages,
        book: groupedPages,
        filter: this.filter
      }, null, {}, 'getVolumesWithPages');
    },
    async changeDisplayMode(newMode = 'list') {
      this.displayMode = null;

      const detailsSelectedAlbum = await this.getVolumesWithPages(newMode === "grid");
      Object.assign(this.selectedAlbum, detailsSelectedAlbum.data.data);

      this.updateListVolumes(newMode);

      if (this.listVolumes) {
        for (const volume of this.listVolumes) {
          if (volume.id === this.selectedVolume.id) {
            Object.assign(this.selectedVolume, volume);
            break;
          }
        }
      }

      this.pages = [];
      this.currentPage = 1;
      this.updateListPages(newMode);
      this.displayMode = newMode;
    },
    updateListVolumes(displayMode = 'list') {
      const objectAwaiting = displayMode === "grid";
      this.listVolumes = null;

      if (this.selectedAlbum.volumes && this.selectedAlbum.volumes.length > 0) {
        this.listVolumes = [this.selectedAlbum];
        this.listVolumes = this.listVolumes.concat(this.selectedAlbum.volumes);
      }

      if (this.listVolumes !== null)
        this.listVolumes.unshift({nom_volume: "Tous", id: "all"});

      if (this.selectedAlbum.pages_exclues
          && ((!objectAwaiting && this.selectedAlbum.pages_exclues.length > 0) ||
              (objectAwaiting && Object.keys(this.selectedAlbum.pages_exclues).length > 0)
          )) {
        if (this.listVolumes === null)
          this.listVolumes = [];

        this.listVolumes.push({nom_volume: "Pages supplémentaires", id: "pages_supp"});
      }
    },
    currentPageChanged(v) {
      if (this.selectedAlbum.id === "all") {
        this.currentPage = v;
        this.updateListPages(this.displayMode)
      }
    }
  },
  watch: {
    filter() {
      if (this.selectedAlbum.id !== "all") {
        this.getVolumesWithPages(this.displayMode === 'grid').then((detailsSelectedAlbum) => {
          Object.assign(this.selectedAlbum, detailsSelectedAlbum.data.data);

          this.updateListVolumes(this.displayMode);

          this.pages = [];
          this.currentPage = 1;
          this.updateListPages(this.displayMode);
        });
      }

      this.currentPageChanged(1);
      this.pages = [];
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header">
            <div class="row mt-4 mt-sm-0 d-flex align-items-center">
              <div class="col-6">
                <b-row>
                  <b-col>
                    <h5 class="mb-0 d-inline">Album
                      <multiselect
                          class="d-inline-block w-auto"
                          v-model="selectedAlbum"
                          :options="listAlbums"
                          :show-labels="false"
                          label="titre"
                          track-by="code"
                          placeholder=""
                          @select="changeSelectedAlbum"
                      ></multiselect>
                    </h5>
                  </b-col>
                  <b-col v-if="listVolumes">
                    <h5 class="mb-0">Volumes
                      <select class="form-select d-inline w-auto" @change="changeSelectedVolume">
                        <option v-for="(item, key) in listVolumes" :key="item.id" :value="key">
                          {{ item.nom_volume }}
                        </option>
                      </select>
                    </h5>
                  </b-col>
                </b-row>
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="float-end">
                  <ul class="nav nav-pills">
                    <li class="nav-item">
                      <a
                          class="nav-link disabled"
                          tabindex="-1"
                          aria-disabled="true"
                      >Affichage :</a
                      >
                    </li>
                    <li
                        class="nav-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="List"
                        @click="selectedAlbum.id !== 'all' ? changeDisplayMode('list') : ''"
                    >
                      <a
                          class="nav-link"
                          :class="displayMode === 'list' ? 'active text-white' : ''"
                          role="button"
                      >
                        <i class="mdi mdi-format-list-bulleted"></i>
                      </a>
                    </li>
                    <li
                        v-if="selectedAlbum.id !== 'all'"
                        class="nav-item"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Grid"
                        @click="changeDisplayMode('grid')"
                    >
                      <a
                          class="nav-link"
                          :class="displayMode === 'grid' ? 'active text-white' : ''"
                          role="button"
                      >
                        <i class="mdi mdi-view-grid-outline"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row mt-4" v-if="displayMode === 'list'">
              <div class="col-sm-12 col-md-4">
                <!--<div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Afficher&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                  </label>
                </div>-->
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-8">
                <div id="tickets-table_filter" class="dataTables_filter text-right">
                  <label class="d-inline-flex align-items-center">
                    Recherche :
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Recherche..."
                        class="form-control-sm w-auto"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <pages-list v-if="displayMode === 'list' && pages"
                        :pages="pages"
                        :per-page="perPage"
                        :total-rows="totalRows"
                        :auto-update-total-rows="autoUpdateTotalRows"
                        :current-page="currentPage"
                        v-on:currentpagechanged="currentPageChanged"
                        :loading="loading"
                        :can-edit="canEdit"
            ></pages-list>
            <pages-grid v-if="displayMode === 'grid' && pages" :pages="pages" :can-edit="canEdit"></pages-grid>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>